import { createSelector } from '@ngrx/store';
import { selectCouponState } from '../reducers';
import { CouponState } from '../reducers/coupon.reducers';


// Coupons Selectors

export const getCouponsTableState = createSelector(
  selectCouponState,
  (state: CouponState) => {
    return {
      total: state.total,
      currentPage: state.currentPage,
      perPage: state.perPage,
      order: state.order,
      direction: state.direction,
      filters: state.filters,
      includes: state.includes
    };
  }
);

export const getCoupons = createSelector(
  selectCouponState,
  (state: CouponState) => state.list
);

export const getTotalCoupons = createSelector(
  getCouponsTableState,
  (tableState) => tableState.total
);

export const getCouponsCurrentPage = createSelector(
  getCouponsTableState,
  (tableState) => tableState.currentPage
);

export const getCouponsPerPage = createSelector(
  getCouponsTableState,
  (tableState) => tableState.perPage
);

export const getCouponsOrder = createSelector(
  getCouponsTableState,
  (tableState) => tableState.order
);

export const getCouponsDirection = createSelector(
  getCouponsTableState,
  (tableState) => tableState.direction
);

export const getFilters = createSelector(
  getCouponsTableState,
  (tableState) => tableState.filters
);

export const getCouponDialogId = createSelector(
  selectCouponState,
  (state: CouponState) => state.dialogId
);

export const getSelectedCoupon = createSelector(
  selectCouponState,
  (state: CouponState) => state.coupon
);

export const getSelectionDialogId = createSelector(
  selectCouponState,
  (state: CouponState) => state.selectionDialogId
);

export const getSelectedCoupons = createSelector(
  selectCouponState,
  (state: CouponState) => state.selectedCoupons
);

export const getSelectedCouponsCurrentPage = createSelector(
  selectCouponState,
  (state: CouponState) => {
    const selectedIds = state.selectedCoupons.map(coupon => coupon.code);
    return state.list?.filter(coupon => selectedIds.includes(coupon.code));
  }
);
